<app-modal class="operation-type-create-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{
                label
                    | translate
            }}</h5>
    </ng-container>
    <div class="content" modal-body>
        <div class="left">
            <app-tool-scan-tree
                [isMaterial]="false"
                labelText="{{'lineSetter.pending-tool-returns.table.details-modal.selectedTools'| translate}}"
                class="toolScanner"
                [items]="pendingToolReturn.returnTools">
            </app-tool-scan-tree>
        </div>
        <div class="right">
            <section class="tool-return-details">
                <h5>{{ 'lineSetter.pending-tool-returns.table.details-modal.detailsTitle' | translate }}</h5>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.toolRequestName' | translate}}"
                    [value]="pendingToolReturn?.toolRequest?.name">
                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.status' | translate}}"
                    [value]="pendingToolReturn?.status">
                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.createdDate' | translate}}"
                    [value]="pendingToolReturn?.createdDate">
                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.createdBy' | translate}}"
                    [value]="pendingToolReturn?.createdBy?.fullName">
                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.assignedTo' | translate}}"
                    [value]="pendingToolReturn?.assignedTo?.fullName">
                </app-display-label>
            </section>
            <section *ngIf="shouldShowReturnInfo()"
                     class="tool-return-details">
                <h5>{{ 'lineSetter.pending-tool-returns.table.details-modal.reasonTitle' | translate }}</h5>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.reason' | translate}}"
                    [value]="pendingToolReturn?.reason">
                </app-display-label>
            </section>
            <section class="tool-return-details"
                     *ngIf="shouldShowClosedInfo()">
                <h5>{{ 'lineSetter.pending-tool-returns.table.details-modal.closeInfoTitle.' + pendingToolReturn.status | translate }}</h5>
                <app-display-label
                    *ngIf="pendingToolReturn.status === 'Canceled'"
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.canceledReason'| translate}}"
                    [value]="pendingToolReturn?.reason">
                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.closedDate.'+ pendingToolReturn.status | translate}}"
                    [value]="pendingToolReturn?.closedDate">

                </app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-returns.table.details-modal.closedBy.'+ pendingToolReturn.status | translate}}"
                    [value]="pendingToolReturn?.assignedTo?.fullName">
                </app-display-label>
            </section>
        </div>
    </div>
    <div class="footer" modal-footer>
        <app-button
            type="simple"
            (clicked)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button *ngIf="computeCanRenderClose(pendingToolReturn)"
                    type="danger"
                    (clicked)="clickCloseToolReturn()">
            {{ 'generic.buttons.cancel' | translate }}
        </app-button>

    </div>
</app-modal>
<app-confirmation-modal (confirmEvent)="onConfirmOrder($event)"
                        [title]="'lineSetter.tool-returns.pages.cancelToolReturn.popupTitle' | translate"
                        [displayReasonLabel]="'lineSetter.tool-returns.pages.cancelToolReturn.popupQuestion' | translate"
                        [displayReasonPlaceholder]="'lineSetter.tool-returns.pages.cancelToolReturn.reasonMessage' | translate"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true"
                        message="{{'lineSetter.tool-returns.pages.popupMessage' | translate}}"
                        [isConfirmationInProgress]="isConfirmationInProgress">
</app-confirmation-modal>
